import "../assets/css/Header.css";
import Mail from "../assets/images/icon-mail-white.svg";
import Phone from "../assets/images/icon-phone-white.svg";
import Logo from "../assets/images/1to1help.png";
// import IconDropdown from "../assets/images/icon-dropdown-arrow-dark.svg";
import Logo152533 from "../assets/images/152533.png";
// import IconMenuDark from "../assets/images/icon-menu-dark.svg";
import React from "react";

const Header = () => {
  return (
    <>
      <div className="top-bar">
        <div className="main-container">
          <div className="top-bar-contents" style={{ float: "right" }}>
            <div className="top-bar-items-wrapper" id="topSection">
              <div className="top-bar-item adjacent-to-item">
                <img src={Mail} alt="" className="top-bar-item-icon" />
                <a
                  href="mailto:connect@1to1help.net"
                  className="text-white small-text"
                >
                  connect@1to1help.net
                </a>
              </div>
              <div className="top-bar-item">
                <img src={Phone} alt="" className="top-bar-item-icon" />
                <a href="tel:18002588999" className="text-white small-text">
                  1800 258 8999{" "}
                </a>
              </div>
              <div className="top-bar-item">
                <img src={Phone} alt="" className="top-bar-item-icon" />
                <a href="tel:18002588121" className="text-white small-text">
                  1800 258 8121{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="navbar-wrapper sticky-top">
        <div className="main-container">
          <div
            data-collapse="medium"
            data-animation="default"
            data-duration="400"
            data-easing="ease"
            data-easing2="ease"
            role="banner"
            className="navbar w-nav"
            style={{ display: "block" }}
          >
            <div className="navbar-row">
              <div className="navbar-left-contents">
                <a
                  href="https://1to1help.net"
                  className="brand adjacent-to-nav-menu w-nav-brand"
                >
                  <img
                    src={Logo}
                    loading="eager"
                    width="200"
                    height="auto"
                    alt=""
                    className="brand-image logoCustom"
                  />
                </a>
              </div>
              <div className="navbar-functions">
                {/* <nav role="navigation" className="nav-menu w-nav-menu">
                  <a
                    href="https://1to1help.net"
                    aria-current="page"
                    className="nav-button w-button w--current"
                  >
                    Home
                  </a>
                  <div
                    data-hover="false"
                    data-delay="0"
                    className="nav-link dropdown w-dropdown"
                  >
                    <div className="dropdown-toggle w-dropdown-toggle">
                      <div className="text-block-3">Products</div>
                      <img
                        src={IconDropdown}
                        loading="eager"
                        alt=""
                        className="dropdown-arrow"
                      />
                    </div>
                    <nav className="dropdown-list w-dropdown-list">
                      <a
                        href="https://1to1help.net/eap/"
                        className="dropdown-link w-dropdown-link"
                      >
                        EAP
                      </a>
                      <a
                        href="https://1to1help.net/maternity/"
                        className="dropdown-link w-dropdown-link"
                      >
                        1to1Maternity​
                      </a>
                      <a
                        href="https://1to1help.net/sap/"
                        className="dropdown-link w-dropdown-link"
                      >
                        SAP
                      </a>
                      <a
                        href="https://1to1help.net/shift-right/"
                        className="dropdown-link w-dropdown-link"
                      >
                        ShiftRight
                      </a>
                    </nav>
                  </div>
                  <a
                    href="https://1to1help.net/res/"
                    className="nav-button w-button"
                  >
                    Resources
                  </a>
                  <a
                    href="https://1to1help.net/contact/"
                    className="nav-button w-button"
                  >
                    Contact Us
                  </a>
                  <a
                    href="https://1to1help.net/faq/"
                    aria-current="page"
                    className="nav-button w-button w--current"
                  >
                    FAQ
                  </a>
                  <a
                    href="https://1to1help.net/about-us/"
                    className="nav-button w-button"
                  >
                    About Us
                  </a>

                  <a
                    href="<%=contextPath%>/signup"
                    className="button small w-inline-block signUpButton"
                  >
                    <div>Sign up</div>
                  </a>
                </nav> */}
                <div className="signUpMargin">
                  <a
                    href="https://1to1help.net/about-us/#requestademo"
                    className="button small w-inline-block"
                  >
                    <div className="customSignINcom">Request a Demo</div>
                    <div className="customSignINhalf">
                      <img
                        alt=""
                        src={Logo152533}
                        style={{
                          maxWidth: "100px",
                          width: "23px",
                          minWidth: "14px",
                        }}
                      />
                    </div>
                  </a>
                </div>
                {/* <div className="signUpMargin">
                  <a
                    href="<%=contextPath%>/signin"
                    className="button small w-inline-block"
                  >
                    <div className="customSignINcom">Sign in</div>
                    <div className="customSignINhalf">
                      <img
                        alt=""
                        src={Logo152533}
                        style={{
                          maxWidth: "100px",
                          width: "23px",
                          minWidth: "14px",
                        }}
                      />
                    </div>
                  </a>
                </div>
                <div className="hide-on-mobile">
                  <a
                    href="<%=contextPath%>/signup"
                    className="button small w-inline-block linebutton"
                  >
                    <div>Sign up</div>
                  </a>
                </div> */}
                {/* <div className="menu-button w-nav-button">
                  <img
                    src={IconMenuDark}
                    loading="eager"
                    alt=""
                    className="menu-button-image"
                  />
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
